import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from '@oscar/theme';
import { TextField } from 'common/components';
import { forEach } from 'lodash';
import moment from 'moment';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { REQUEST_STATUS } from 'common/constants';
import { funcLocationOption } from '../data';
import { FORMAT_DATE } from 'common/constants';
import { useFormContext } from '@oscar/form';
import { useDeepCompareEffect } from '@oscar/utils';
import classnames from 'classnames';
import useStatus from 'views/pages/create-instrulation/hooks/useStatus';
import { useAuth } from 'features/auth';

export const SearchResult = (props: any) => {
  const { addItem, item, field, readOnly, removeItem, resetItem, notAllowAdd } =
    props;
  const [formContext] = useFormContext();
  const [statusRequest] = useStatus();
  const [auth] = useAuth();
  const [sisfold, setSisfold] = useState<any>([]);
  console.log(item, 'item');
  const sisfoldDetail = formContext.form?.getFieldValue('sisfoldDetail');
  const listScaffoldDetail =
    formContext.form?.getFieldValue('listScaffoldDetail');
  console.log(sisfoldDetail);
  useEffect(() => {
    setSisfold(sisfoldDetail);
  }, [item, sisfold, sisfoldDetail]);

  useDeepCompareEffect(() => {
    if (listScaffoldDetail && listScaffoldDetail.length > 0) {
      formContext?.form?.setFieldsValue({ isScaffoldingRequire: true });
    } else {
      formContext?.form?.setFieldsValue({ isScaffoldingRequire: false });
    }
  }, [listScaffoldDetail?.length]);
  const mapData = (status: any) => {
    for (const key in REQUEST_STATUS) {
      if (status === REQUEST_STATUS[key as keyof typeof REQUEST_STATUS].VALUE) {
        return REQUEST_STATUS[key as keyof typeof REQUEST_STATUS].TEXT;
      }
    }
  };

  return (
    <div className="notification-detail">
      {!readOnly && (
        <div className="notification-detail-title">Search Result</div>
      )}
      <div className="notification-detail-content">
        {item || sisfold ? (
          item?.isLocal || (item === undefined && sisfold.length === 0) ? (
            <div className="notification-detail-content-placeholder warning">
              {item?.isLocal && <div>No Scaffold ID found</div>}
              Add Request from the search result to the list or click Create New
              to create a new one
            </div>
          ) : (
            <div>
              <Row gutter={12}>
                <Col span={24}>
                  <div className="search-header">
                    <div className="search-header_id">
                      <TextField
                        label="Scaffold ID"
                        value={item?.scaffoldRefNo || sisfold[0]?.scaffoldID}
                      />
                    </div>
                    {!field && !item?.isLocal && item && (
                      <div>
                        <Button
                          className="add-to-list-button"
                          onClick={() => {
                            resetItem?.();
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          type="primary"
                          className="add-to-list-button"
                          disabled={notAllowAdd}
                          onClick={() => addItem?.(item)}
                        >
                          Add to list
                        </Button>
                      </div>
                    )}
                    {field &&
                      statusRequest?.state === 'EDIT' &&
                      (auth.getUserRoles().includes('OSCAR') ||
                        (auth.getUserRoles().includes('PAINTING') &&
                          statusRequest?.type === 'PAINTING') ||
                        (auth.getUserRoles().includes('INSULATION') &&
                          statusRequest?.type &&
                          ['INSTATEMENT', 'REMOVAL'].includes(
                            statusRequest.type,
                          ))) && (
                        <Button
                          type="primary"
                          className="update-button"
                          onClick={() => {
                            removeItem?.(field);
                          }}
                          size="small"
                        >
                          Remove from list
                        </Button>
                      )}
                  </div>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={24}>
                  <TextField
                    label="Status"
                    value={
                      item
                        ? () => mapData(item?.status)
                        : mapData(sisfold[0]?.status)
                    }
                    //mappingData={SAP_STATUS_LIST}
                    primary
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={24}>
                  <TextField
                    label="Job Description"
                    value={
                      item ? item?.description : sisfold[0]?.jobDescription
                    }
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={12}>
                  <TextField
                    label="Function Location"
                    value={
                      item
                        ? item?.functionalLocation || 'No functional location'
                        : sisfold[0]?.functionalLocation ||
                          'No functional location'
                    }
                    //mappingData={funcLocationOption}
                  />
                </Col>
                <Col span={12}>
                  <TextField
                    label="Location Description"
                    value={
                      item
                        ? item?.locationDescription || 'No location description'
                        : sisfold[0]?.locationDescription ||
                          'No location description'
                    }
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={12}>
                  <TextField
                    label="Start Date"
                    value={
                      !(item === undefined)
                        ? moment(item?.startOn)?.format(
                            FORMAT_DATE.SHORT_MONTH_DATE,
                          )
                        : moment(sisfold[0]?.startDate)?.format(
                            FORMAT_DATE.SHORT_MONTH_DATE,
                          )
                    }
                  />
                </Col>
                <Col span={12}>
                  <TextField
                    label="End Date"
                    value={
                      !(item === undefined)
                        ? moment(item?.endOn)?.format(
                            FORMAT_DATE.SHORT_MONTH_DATE,
                          )
                        : moment(sisfold[0]?.endDate)?.format(
                            FORMAT_DATE.SHORT_MONTH_DATE,
                          )
                    }
                  />
                </Col>
              </Row>
            </div>
          )
        ) : (
          <div className={'notification-detail-content-placeholder'}>
            Add Request from the search result to the list or click Create New
            to create a new one
          </div>
        )}
      </div>
    </div>
  );
};
